import * as types from './mutation-types';
import User from 'common/bean/user';

const mutations = {
  [types.SET_USER_STATE](state, user) {
    state.user = new User(user);
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js